import React, { useEffect } from "react";

import "./style.scss";
import loadingImg from "../../assets/images/loading.gif";

interface Props {
  page?: number;
  size?: number;
  loading: boolean;
  loadingStartBg?: string;
  loadingEndBg?: string;
  scrollClassName?: string;
  extraClassName?: string;
  hasNextPage?: boolean;
  moreDom?: React.ReactNode | string | null;
  style?: React.CSSProperties;
}

const Loading = (props: Props) => {
  const {
    page = 1,
    size = 48,
    loading = true,
    scrollClassName = "",
    extraClassName = "",
    loadingStartBg = "transparent",
    loadingEndBg = "transparent",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hasNextPage = true,
    moreDom = null,
    style = {},
  } = props;

  useEffect(() => {
    // 防止滚动加载后页面微回弹
    if (scrollClassName) {
      const dom: any = document.querySelector(scrollClassName);
      if (loading && page > 1) {
        dom.style.overflow = "hidden";
      } else {
        dom.style.overflowY = "auto";
      }
    }
  }, [loading]);

  return hasNextPage ? (
    <div className={`my-loading--wrapper ${extraClassName}`} style={style}>
      {loading ? (
        <div
          className="my-loading"
          style={
            loading
              ? { backgroundColor: loadingStartBg }
              : { backgroundColor: loadingEndBg }
          }
        >
          <img
            src={loadingImg}
            alt="loading"
            style={{ width: window.rem(size) }}
          />
          <p>加载中…</p>
        </div>
      ) : (
        moreDom
      )}
    </div>
  ) : (
    <></>
  );
};

export default Loading;
